<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <div class="quill" v-html="contents.html"></div>
            </div>
          </section>

        </div>
      </div>

      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="テキストの編集" :label-width="labelWidth">
          <vue-editor v-model="contents.html" :editorToolbar="customToolbar" :id="'quill-editor-' + _uid"></vue-editor>
        </el-form-item>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import ComponentBase from '@/components/mixins/ComponentBase'

export default {
  name: 'rich-text-editor-1',
  mixins: [ComponentBase],
  components: {
    VueEditor
  },
  data: function () {
    return {
      labelWidth: '120px',
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        // ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'script': 'sub'}, {'script': 'super'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{ 'align': [] }],
        [{'direction': 'rtl'}],
        [{'size': ['small', false, 'large', 'huge']}],
        [{'color': []}, {'background': []}],
        ['clean']
      ]
    }
  },
  computed: {
  },
  methods: {
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          ${contents.html}
        </div>
      </section>
      `.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  },
  created: async function () {
    if (!this.posts.length) await this.$store.dispatch('wordpress/posts/fetch')

    // migration
    if (!this.contents.padding) this.contents.padding = {y: 4}
  }
}
</script>

<style lang="scss">
.quill {
  @import './quill.snow';
}
</style>

<style lang="scss" scoped>
.native {
  @import './RichTextEditor1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './RichTextEditor1.s.scss';
}
.tablet,
.desktop {
  @import './RichTextEditor1.m.scss';
}
.desktop {
  @import './RichTextEditor1.l.scss';
}

.ql-image {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/contents/RichTextEditor1/RichTextEditor1.vue